"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DamageReflectEffectHandler = exports.DamageReflectEffectArgs = void 0;
const CustomScript_1 = require("../../event-handlers/core/CustomScript");
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class DamageReflectEffectArgs {
    constructor(percent, damageTypeOverride) {
        this.percent = percent;
        this.damageTypeOverride = damageTypeOverride;
        this.__type = EffectType_1.EffectType.DamageReflect;
        this.__typeName = "DamageReflect";
        this.name = "Damage Reflection";
        this.harmful = false;
    }
}
exports.DamageReflectEffectArgs = DamageReflectEffectArgs;
let DamageReflectEffectHandler = class DamageReflectEffectHandler {
    apply(sequence, container, state) {
        const scriptArgs = {
            percent: state.args.percent * .01,
            damageTypeOverride: state.args.damageTypeOverride
        };
        state.meta.eventHandlerId = container.registerEventHandler(state.creatorId, EventType_1.EventType.Damaged, Schedule_1.Schedule.Unlimited, new CustomScript_1.CustomScriptEventHandlerArgs("Effect_DamageReflect", scriptArgs));
    }
    remove(sequence, container, state) {
        container.cancelEventHandler(state.meta.eventHandlerId);
    }
};
DamageReflectEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.DamageReflect)
], DamageReflectEffectHandler);
exports.DamageReflectEffectHandler = DamageReflectEffectHandler;
